import { createSlice  } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

// We will use these variables to return the products and the number of products inside the cart and the total price
const initialState = {
    cartItems: localStorage.getItem('cartItems') ? JSON.parse(localStorage.getItem('cartItems')) : [] ,
    nbrItems: localStorage.getItem('cartNbrItems') ? JSON.parse(localStorage.getItem('cartNbrItems')) : 0,
    total: localStorage.getItem('cartTotalPrice') ? JSON.parse(localStorage.getItem('cartTotalPrice')) : 0,
    discountedPrice:Cookies.get('discountedPrice') ? JSON.parse(Cookies.get('discountedPrice')) : 0,
    couponCode:Cookies.get('couponCode') ? JSON.parse(Cookies.get('couponCode')) : "",
    //discount: Cookies.get('discount') ? JSON.parse(Cookies.get('discount')) : "",
  };

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    // This function is used to add an item to the cart
    addItem: (state,action)=>{
        // If the product is out of stock then don't add it to cart
        if (action.payload.countInStock <= 0){
          window.alert("Product is out of stock.")
          return;
        }
        const existItem = state.cartItems.find(item => item._id === action.payload._id)
        // Check if the product already exists in the cart, if not then we add it to the cart
        if (!existItem){
          state.cartItems.push(action.payload)
          state.nbrItems+=1
          state.total+=Number(action.payload.price)
          state.discountedPrice=0
          //state.discountedPrice=state.total - (state.total * (state.discount/100))
          // Save products added in cart, the number of products in cart and their total price in cookies
          localStorage.setItem('cartItems',JSON.stringify(state.cartItems))
          localStorage.setItem('cartNbrItems',JSON.stringify(state.nbrItems))
          localStorage.setItem('cartTotalPrice',JSON.stringify(state.total))
        }
        
        
    },

    // This function is used to remove an item from the cart
    removeItem: (state,action)=>{
        // remove product from cart
        state.cartItems = state.cartItems.filter(item =>item._id !== action.payload._id);
        // decrease the number of products in cart
        state.nbrItems-=1
        // Update the total price of products in cart
        state.total-=Number(action.payload.price)
        state.discountedPrice=0
        
        if (state.nbrItems==0){
          Cookies.remove("couponCode")
          Cookies.remove("discountedPrice")
        }
        //state.discountedPrice=state.total - (state.total * (state.discount/100))
        // Update those changes in cookies
        localStorage.setItem('cartItems',JSON.stringify(state.cartItems))
        localStorage.setItem('cartNbrItems',JSON.stringify(state.nbrItems))
        localStorage.setItem('cartTotalPrice',JSON.stringify(state.total))
    },

    // Remove all products from cart
    clear:(state)=>{
      // reinitialize the number of items and total price to 0
      state.cartItems=[]
      state.nbrItems=0
      state.total=0
      // Remove the cookies
      localStorage.removeItem('cartItems')
      localStorage.removeItem('cartNbrItems')
      localStorage.removeItem('cartTotalPrice')
    },

    setDiscountedPrice: (state,action)=>{
        state.discountedPrice=action.payload
        Cookies.set('discountedPrice',JSON.stringify(state.discountedPrice))
    },

    // setDiscount: (state,action)=>{
    //     state.discount=action.payload
    //     Cookies.set('discount',JSON.stringify(state.discount))
    // },

    saveCouponCode: (state,action)=>{
        state.couponCode=action.payload
        Cookies.set('couponCode',JSON.stringify(state.couponCode))
    },

    clearDiscountedPrice: ()=>{
        Cookies.remove('discountedPrice')
    },

    // clearDiscount: ()=>{
    //     Cookies.remove('discount')
    // },

    clearCouponCode: ()=>{
        Cookies.remove('couponCode')
    },
  },
});

export const { addItem,removeItem,clear,setDiscountedPrice,clearDiscountedPrice,saveCouponCode,clearCouponCode,setDiscount,clearDiscount} = cartSlice.actions;

export const selectCart = (state) =>state.cart.cartItems;
export const selectNbrItems = (state) => state.cart.nbrItems;
export const selectDiscountedPrice = (state) =>state.cart.discountedPrice;
export const selectCouponCode = (state) =>state.cart.couponCode;
//export const selectDiscount = (state) =>state.cart.discount;
export const selectTotal = (state) => state.cart.total;
export default cartSlice.reducer;
